<template>
  <v-form
    v-model="$storeUniversite.validInfoScolaire"
    ref="formulaireInfoScolaire"
    lazy-validation
  >
    <v-dialog v-model="dialog.informations.model" width="500">
      <v-card>
        <v-card-title>Informations</v-card-title>
        <v-card-text>
          <p v-html="dialog.informations.texte"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog.informations.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Partie informations baccalauréat -->
    <v-expansion-panels multiple v-model="Panel.Baccalaureat">
      <v-expansion-panel ref="baccalaureat">
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.InformationBac }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.TypeDeBac"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeBac"
                :label="$storeUniversite.label.TypeDeBac"
                @change="CheckVilleMaroc"
                outlined
                :rules="[$rules.obligatoire()]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .AnneeDObtentionDuBaccalaureatOuEspere
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.AnneeScolaireBac"
                :label="$storeUniversite.label.AnneeObtentionBac"
                outlined
                :rules="[$rules.obligatoire()]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.TypeBacAutre"
                :label="$storeUniversite.label.TypeDeBacAutre"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="$storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac?
                [$rules.obligatoire(), $rules.latin()]
                : []"
                class="asterisk"
                v-show="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac
                "
              ></v-text-field>
              <v-text-field
                v-show="
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.TypeBacMarocain
                "
                dense
                v-mask="$storeCommun.MaskCodeMassar"
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .CodeMassarCodeNationalEtudiant
                "
                :label="$storeUniversite.label.CodeEtudiant"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.TypeBacMarocain
                    ? [$rules.alphaNumerique(), $rules.codeMassarFormat()]
                    : [$rules.alphaNumerique()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.TypeBacMarocain
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain
              "
            >
              <v-text-field
                dense
                v-mask="$storeCommun.MaskCodeMassar"
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .ConfirmCodeMassarCodeNationalEtudiant
                "
                :label="$storeUniversite.label.ConfirmCodeEtudiant"
                outlined
                :rules="[
                  $rules.Equal(
                    $storeUniversite.inscription.InfosBac
                      .CodeMassarCodeNationalEtudiant
                  ),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
                @paste.prevent
                @copy.prevent
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.DomaineBacFr"
                :label="$storeUniversite.label.FiliereDuBac"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.TypeDEtablissement
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeEtablissementPublicPrive"
                :label="$storeUniversite.label.TypeEtablissement"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !=
                $storeCatalogue.DataId.TypeBacMarocain
              "
              cols="12"
              md="6"
            >
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.PaysDuLycee"
                :label="$storeUniversite.label.PaysLycee"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeUniversite.inscription.ReadOnly"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"

              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ==
                $storeCatalogue.DataId.TypeBacAutre || $storeUniversite.inscription.InfosBac.TypeDeBac ==
                $storeCatalogue.DataId.TypeBacFrancais
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.VilleDuLycee"
                :label="$storeUniversite.label.VilleEtablissement"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire(), $rules.latin()]"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-else>
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.VilleDuLycee"
                item-text="lang00"
                item-value="lang00"
                :items="$storeCatalogue.VilleMaroc"
                :label="$storeUniversite.label.VilleEtablissement"
                outlined
                @change="CheckEtablissement"
                :disabled="$storeUniversite.inscription.ReadOnly"
              ></v-autocomplete>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !=
                $storeCatalogue.DataId.TypeBacMarocain
              "
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NomDuLycee"
                :label="$storeUniversite.label.NomEtablissement"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire(), $rules.latin()]"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Lycee"
                item-text="label"
                item-value="idCrypte"
                :items="$storeCatalogue.EtablissementMaroc"
                :label="$storeUniversite.label.NomEtablissement"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacMarocain
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.AutreVilleLycee"
                :label="$storeUniversite.label.VilleEtablissementAutre"
                :rules="[
                  $rules.latin(),
                  $rules.obligatoiresField(
                    $storeUniversite.inscription.InfosBac.VilleDuLycee
                  ),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                v-if="!$storeUniversite.inscription.InfosBac.VilleDuLycee"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NomDuLycee"
                :label="$storeUniversite.label.NomEtablissementAutre"
                :rules="[
                  $rules.latin(),
                  $rules.obligatoiresField(
                    $storeUniversite.inscription.InfosBac.Lycee
                  ),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                v-if="!$storeUniversite.inscription.InfosBac.Lycee"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .AvezVousObtenuVotreDiplome
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.ObtentionBac"
                outlined
                :rules="[$rules.obligatoire()]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
                v-if="
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) >= 0
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-if="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain
                "
                v-model="
                  $storeUniversite.inscription.InfosBac.SystemeNotationBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.SystemeNotationBac"
                :label="$storeUniversite.label.SystemeNotationBac"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain
                    ? [$rules.obligatoire()]
                    : []
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain
                    ? 'asterisk'
                    : ''
                "
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.BaremBac"
                :label="$storeUniversite.label.BaremeNote"
                outlined
                :disabled="
                  $storeUniversite.lectureSeuleBarem ||
                  $storeUniversite.inscription.ReadOnly
                "
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .SpecificationDuBaremeDeBac
                "
                :label="$storeUniversite.label.SpecificationBaremBac"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="
                $storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <p>{{ $storeUniversite.label.Abcd }}</p>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui ||
                $storeUniversite.inscription.NiveauDEtude.indexOf(
                  $storeCatalogue.DataId.PostBac
                ) < 0
              "
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MoyGenDuBac"
                :label="$storeUniversite.label.MoyGenAnnuelleBac"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6"> </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- NOTES LYCEE POST BAC -->
      <v-expansion-panel
        ref="noteslycee"
        v-if="
          $storeUniversite.inscription.NiveauDEtude.indexOf(
            $storeCatalogue.DataId.PostBac
          ) >= 0
        "
      >
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.ReleveNoteBac }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.AutreBac
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.Moy1erAnneeBac"
                :label="
                  $storeUniversite.displayLabel(
                    $storeUniversite.inscription.InfosBac.TypeDeBac
                  )
                "
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-else>
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac
                    .MoyGen2EmeAnneeCycleLycee
                "
                :label="$storeUniversite.label.MoyGen2eCycleLycee"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="
                  $storeUniversite.inscription.InfosBac.MoyenneSem1Trim1Bac
                "
                dense
                :label="$storeUniversite.label.MoyenneSem1Trim1Bac"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC FRANCAIS -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <!-- SPECIALITE 1 -->
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Specialite1"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Specialite1Bac"
                :label="$storeUniversite.label.Spécialite1"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
                @change="
                  CheckSpecialite2(
                    $storeUniversite.inscription.InfosBac.Specialite1
                  )
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteSpecialite1"
                :label="$storeUniversite.label.Specialite1note"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC FRANCAIS -->
          <!-- SPECIALITE 2 -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosBac.Specialite2"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Specialite2Bac"
                :label="$storeUniversite.label.Specialite2"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
                @change="
                  CheckSpecialite1(
                    $storeUniversite.inscription.InfosBac.Specialite2
                  )
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteSpecialite2"
                :label="$storeUniversite.label.Specialite2note"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC FRANCAIS -->
          <!-- MATH EXPERT OPTION -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacFrancais
            "
          >
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.MathsExpertOption
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.MathsExpertOption"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui &&
                $storeUniversite.inscription.InfosBac.MathsExpertOption ===
                  $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.NoteMathsExpertOption
                "
                :label="$storeUniversite.label.MathsExpertNote"
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC MAROCAIN -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
              $storeCatalogue.DataId.TypeBacMarocain
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.NoteBacRegional"
                :label="$storeUniversite.label.MoyenneExamenRegional"
                outlined
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.NoteDuBacNational
                "
                :label="$storeUniversite.label.MoyenneNationalBac"
                outlined
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremBac),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- BAC MAROCAIN OU AUTRE ET DOMAINE AUTRE -->
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math1erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacSem1
                    : $storeUniversite.label.Math1BacSem1Autre
                "
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                $storeCatalogue.DataId.TypeBacMarocain
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math1erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacSem2
                    : $storeUniversite.label.Math1BacSem2Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.Maths1ErBacTrim3"
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math1BacTrimestre3
                    : $storeUniversite.label.Math1BacTrimestre3Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.AutreBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac,
                }"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math2erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math2BacSem1
                    : $storeUniversite.label.Math2BacSem1Autre
                "
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Math2erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Math2BacSem2
                    : $storeUniversite.label.Math2BacSem2Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique &&
                    $storeUniversite.inscription.InfosBac
                      .AvezVousObtenuVotreDiplome ===
                      $storeCatalogue.DataId.Oui)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique &&
                      $storeUniversite.inscription.InfosBac
                        .AvezVousObtenuVotreDiplome ===
                        $storeCatalogue.DataId.Oui),
                }"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Maths2EmeBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Maths2BacTrim3
                    : $storeUniversite.label.Maths2BacTrim3Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.AutreBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac,
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col
              cols="12"
              md="12"
              v-if="
                ($storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain ||
                  $storeUniversite.inscription.InfosBac
                    .AvezVousObtenuVotreDiplome ===
                    $storeCatalogue.DataId.Oui) &&
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacAutre
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.MathsNational"
                :label="$storeUniversite.label.MathNational"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac
                    .DomaineDuBaccalaureat !==
                  $storeCatalogue.DataId.AutreFiliereBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosBac
                    .DomaineDuBaccalaureat !==
                  $storeCatalogue.DataId.AutreFiliereBac
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacSem1
                    : $storeUniversite.label.Physique1BacSem1Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacSem2
                    : $storeUniversite.label.Physique1BacSem2Autre
                "
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col cols="12" md="6">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique1ErBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique1BacTrim3
                    : $storeUniversite.label.Physique1BacTrim3Autre
                "
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.AutreBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac,
                }"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2erBacSemestre1
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacSem1
                    : $storeUniversite.label.Physique2BacSem1Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique),
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.AutreBac &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2erBacSemestre2
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacSem2
                    : $storeUniversite.label.Physique2BacSem2Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac ||
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.AutreBac &&
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat ===
                      $storeCatalogue.DataId.EquivalentScientifique &&
                    $storeUniversite.inscription.InfosBac
                      .AvezVousObtenuVotreDiplome ===
                      $storeCatalogue.DataId.Oui)
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                      $storeCatalogue.DataId.AutreBac ||
                    ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                      $storeCatalogue.DataId.AutreBac &&
                      $storeUniversite.inscription.InfosBac
                        .DomaineDuBaccalaureat ===
                        $storeCatalogue.DataId.EquivalentScientifique &&
                      $storeUniversite.inscription.InfosBac
                        .AvezVousObtenuVotreDiplome ===
                        $storeCatalogue.DataId.Oui),
                }"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.Physique2EmeBacTrim3
                "
                :label="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !=
                  $storeCatalogue.DataId.AutreBac
                    ? $storeUniversite.label.Physique2BacTrim3
                    : $storeUniversite.label.Physique2BacTrim3Autre
                "
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.AutreBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac.TypeDeBac !==
                    $storeCatalogue.DataId.AutreBac,
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosBac.TypeDeBac ===
                $storeCatalogue.DataId.TypeBacMarocain ||
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.AutreBac) &&
              !$storeCatalogue.DatatIdFilieresNonMaroc.includes(
                $storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat
              )
            "
          >
            <v-col
              cols="12"
              md="12"
              v-if="
                ($storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacMarocain ||
                  $storeUniversite.inscription.InfosBac
                    .AvezVousObtenuVotreDiplome ===
                    $storeCatalogue.DataId.Oui) &&
                $storeUniversite.inscription.InfosBac.TypeDeBac !==
                  $storeCatalogue.DataId.TypeBacAutre
              "
            >
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosBac.PhysiqueNational"
                :label="$storeUniversite.label.PhysiqueNational"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac
                    .DomaineDuBaccalaureat !==
                  $storeCatalogue.DataId.AutreFiliereBac
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac
                      .DomaineDuBaccalaureat !==
                    $storeCatalogue.DataId.AutreFiliereBac,
                }"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosBac.TypeDeBac ===
                  $storeCatalogue.DataId.TypeBacMarocain &&
                $storeUniversite.inscription.InfosBac
                  .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosBac.MoyenneCcAnneeBac
                "
                :label="$storeUniversite.label.MoyenneCcAnneeBac"
                :rules="
                  $storeUniversite.inscription.InfosBac
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremBac),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremBac),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="{
                  asterisk:
                    $storeUniversite.inscription.InfosBac
                      .AvezVousObtenuVotreDiplome ===
                    $storeCatalogue.DataId.Oui,
                }"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <br />
    <v-expansion-panels
      multiple
      v-model="Panel.EtudesSuperieures"
      v-if="
        $storeUniversite.inscription.NiveauDEtude.indexOf(
          $storeCatalogue.DataId.PostBac
        ) < 0
      "
    >
      <v-expansion-panel ref="etudessup">
        <v-expansion-panel-header>
          <h3>
            {{ $storeUniversite.label.InformationLicence }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.FiliereIng"
                :label="$storeUniversite.label.DiplomeActuel"
                :disabled="$storeUniversite.inscription.ReadOnly"
                outlined
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :label="$storeUniversite.label.ObtentionBac"
                :rules="
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) < 0
                    ? [$rules.obligatoire()]
                    : []
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) < 0
                    ? 'asterisk'
                    : ''
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .PaysObtentionDuDiplome
                "
                :label="$storeUniversite.label.PaysEtablissement"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                outlined
                @change="CheckVilleMaster()"
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .PaysObtentionDuDiplome !== $storeCatalogue.DataId.Maroc
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VilleObtentionDuDiplome
                "
                :label="$storeUniversite.label.VilleObtenionDiplome"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacFrancais ||
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacAutre ||
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacMarocain
                    ? [$rules.obligatoire(), $rules.latin()]
                    : [$rules.latin()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col v-else cols="12" md="4">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VilleObtentionDuDiplome
                "
                item-text="lang00"
                item-value="lang00"
                :items="$storeCatalogue.VilleMaroc"
                :label="$storeUniversite.label.VilleObtenionDiplome"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .PaysObtentionDuDiplome === $storeCatalogue.DataId.Maroc
                    ? [$rules.obligatoire()]
                    : []
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosMaster.NomEtablissement"
                :label="$storeUniversite.label.NomEtablissementMaster"
                :rules="
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacFrancais ||
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacAutre ||
                  $storeUniversite.inscription.InfosBac.TypeDeBac ===
                    $storeCatalogue.DataId.TypeBacMarocain
                    ? [$rules.obligatoire(), $rules.latin()]
                    : [$rules.latin()]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                dense
                v-model="$storeUniversite.inscription.InfosMaster.PublicPrive"
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.TypeEtablissementPublicPrive"
                :label="$storeUniversite.label.TypeEtablissement"
                outlined
                :rules="[$rules.obligatoire()]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosMaster.Majeure"
                :label="$storeUniversite.label.Major"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire(), $rules.latin()]"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    dense
                    v-model="myDateFormated3"
                    :label="$storeUniversite.label.DateEntreeLicence"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[$rules.obligatoire()]"
                    :disabled="$storeUniversite.inscription.ReadOnly"
                    class="asterisk"
                  />
                </template>
                <v-date-picker
                  v-model="$storeUniversite.inscription.InfosMaster.DateEntree"
                  :rules="[$rules.obligatoire()]"
                  @input="menu4 = false"
                  :disabled="$storeUniversite.inscription.ReadOnly"
                  class="asterisk"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="$storeUniversite.inscription.ReadOnly"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    dense
                    v-model="myDateFormated2"
                    :label="$storeUniversite.label.DateFin"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="[$rules.obligatoire()]"
                    :disabled="$storeUniversite.inscription.ReadOnly"
                    class="asterisk"
                  />
                </template>
                <v-date-picker
                  v-model="
                    $storeUniversite.inscription.InfosMaster.DateDeFinOuEspere
                  "
                  :rules="[$rules.obligatoire()]"
                  class="asterisk"
                  @input="menu3 = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VotreEchelleDeNotation
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.BaremBac"
                :label="$storeUniversite.label.EchelleNotation"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .VotreEchelleDeNotation ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .VeuillezPreciserVotreEchelleDeNotation
                "
                :label="$storeUniversite.label.EchelleNotationPrecision"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :rules="[$rules.obligatoire()]"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="
                $storeUniversite.inscription.InfosMaster
                  .VotreEchelleDeNotation ===
                $storeCatalogue.DataId.BaremBacAutre
              "
            >
              <p>
                {{ $storeUniversite.label.Abcd }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-if="
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                "
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.NoteFinaleDuDiplome
                "
                :label="$storeUniversite.label.NoteFinalDiplome"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome != $storeCatalogue.DataId.Non
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome != $storeCatalogue.DataId.Non
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-if="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.BacPlus1 ||
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.BacPlus2 ||
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.PrepaScientifique ||
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.PrepaGrandeEcole
                "
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .SystemeNotationPostBac
                "
                :item-text="$storeUniversite.itemLang"
                item-value="id"
                :items="$storeCatalogue.SystemeNotationPostBac"
                :label="$storeUniversite.label.SystemeNotationPostBac"
                outlined
                :rules="[$rules.obligatoire()]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        ref="notesetudessup"
        v-if="
          $storeUniversite.inscription.InfosMaster
            .VotreDiplomeActuelEnCoursOuObtenu != null
        "
      >
        <v-expansion-panel-header>
          <h3>{{ $storeUniversite.label.NoteMasterEtProgIngenieur }}</h3>
        </v-expansion-panel-header>
        <div style="margin-left: 25px;">
        <h5>{{ $storeUniversite.label.ExplicationNbDeRattrapage }}</h5>
        </div>
        <v-expansion-panel-content>
          <br/>
          <!-- SEMESTRE 1 & 2 -->
          <v-row>
            <v-col cols="12" :md="columnValue">
              <!-- Semestre 1 / Année 1 trimestre 1 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem1NoteFinale
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.Semestre1
                    : $storeUniversite.label.A1TrimSem1
                "
                outlined
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremMaster),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <!-- NB rattrapage 1 / année 1 nb rattrapage trim 1 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem1NbDeRattrapage
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.NbrRattrapages1
                    : $storeUniversite.label.A1NBDeRattrapageTrimSem1
                "
                :rules="[$rules.obligatoireWithZero(), $rules.entier()]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue"
            v-if="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !==
                    $storeCatalogue.DataId.BacPlus1
                    ||
                    ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.BacPlus1
                    && $storeUniversite.inscription.InfosMaster.AvezVousObtenuVotreDiplome
                    === $storeCatalogue.DataId.Oui)">
              <!-- SEM2 / Année 1 Trim 2 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem2NoteFinale
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.Semestre2
                    : $storeUniversite.label.A1TrimSem2
                "
                outlined
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremMaster),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue"
            v-if="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !==
                    $storeCatalogue.DataId.BacPlus1
                    ||
                    ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu ===
                    $storeCatalogue.DataId.BacPlus1
                    && $storeUniversite.inscription.InfosMaster.AvezVousObtenuVotreDiplome
                    === $storeCatalogue.DataId.Oui)">
              <!-- NB RATTR 2 / ANNEE 1 NB RATTR TRIM 2 -->
              <v-text-field
                dense
                outlined
                :label="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.NbrRattrapages2
                    : $storeUniversite.label.A1NBDeRattrapageTrimSem2
                "
                :rules="[$rules.obligatoireWithZero(), $rules.entier()]"
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem2NbDeRattrapage
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              (($storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ===
                $storeCatalogue.DataId.BacPlus1
              && $storeUniversite.inscription.InfosMaster.AvezVousObtenuVotreDiplome
                == $storeCatalogue.DataId.Oui) ||
                $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.BacPlus2 ||
                $storeUniversite.inscription.InfosMaster
                  .VotreDiplomeActuelEnCoursOuObtenu ==
                  $storeCatalogue.DataId.PrepaScientifique ||
                $storeUniversite.inscription.InfosMaster
                  .VotreDiplomeActuelEnCoursOuObtenu ==
                  $storeCatalogue.DataId.PrepaGrandeEcole) &&
              $storeUniversite.inscription.InfosMaster.SystemeNotationPostBac !=
                $storeCatalogue.DataId.SystemeNotationPostBacSemestriel
            "
          >
          <v-col cols="12" md="6">
              <!-- TRIM 3 -->
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosMaster.Annee1TRIM3"
                :label="$storeUniversite.label.Trimestre3"
                outlined
                :rules="[
                  $rules.obligatoire(),
                  $rules.EstNumerique(),
                  $rules.loanMin(ValeurBaremMaster),
                ]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <!-- NB RATTR ANNEE 1 TRIM 3 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .Annee1Trim3NBDeRattrapage
                "
                :label="$storeUniversite.label.NBDeRattrapage13"
                :rules="[$rules.obligatoireWithZero(), $rules.entier()]"
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                class="asteriskBefore"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SEMESTRE 3 & 4 -->
          <v-row v-if="$storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !==
                $storeCatalogue.DataId.BacPlus1">
            <v-col cols="12" :md="columnValue">
              <!-- SEM 3 / A 2 T1 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem3NoteFinale
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.Semestre3
                    : $storeUniversite.label.A2TrimSem1
                "
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),
                      ]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <!-- NB RATTR SEM 3 / A2 T 1 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem3NbDeRattrapage
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.NbrRattrapages3
                    : $storeUniversite.label.A2NBDeRattrapageTrimSem1
                "
                outlined
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <!-- SEM 4 / A2 SEM 2 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem4NoteFinale
                "
                :label="
                $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.Semestre4
                    : $storeUniversite.label.A2TrimSem2
                "
                outlined
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ] : [$rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),]"
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="columnValue">
              <!-- NB RATTR SEM 4 / A2 TRIM 2 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem4NbDeRattrapage
                "
                :label="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaScientifique &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.PrepaGrandeEcole &&
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu != null
                    ? $storeUniversite.label.NbrRattrapages4
                    : $storeUniversite.label.A2NBDeRattrapageTrimSem2
                "
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              ($storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu ==
                $storeCatalogue.DataId.BacPlus2 ||
                $storeUniversite.inscription.InfosMaster
                  .VotreDiplomeActuelEnCoursOuObtenu ==
                  $storeCatalogue.DataId.PrepaScientifique ||
                $storeUniversite.inscription.InfosMaster
                  .VotreDiplomeActuelEnCoursOuObtenu ==
                  $storeCatalogue.DataId.PrepaGrandeEcole) &&
              $storeUniversite.inscription.InfosMaster.SystemeNotationPostBac !=
                $storeCatalogue.DataId.SystemeNotationPostBacSemestriel &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !==
                $storeCatalogue.DataId.BacPlus1
            "
          >
            <v-col cols="12" md="6">
              <!-- A 2 TRIM 3 -->
              <v-text-field
                dense
                v-model="$storeUniversite.inscription.InfosMaster.Annee2Trim3"
                :label="$storeUniversite.label.Trimestre23"
                outlined
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <!-- NB RATTR A 2 TRIM 3 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster
                    .Annee2Trim3NBDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages23"
                outlined
                :rules="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  ($storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus1 &&
                    $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus2 &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaScientifique &&
                    $storeUniversite.inscription.InfosMaster
                      .VotreDiplomeActuelEnCoursOuObtenu !=
                      $storeCatalogue.DataId.PrepaGrandeEcole) ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asteriskBefore'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- SEMESTRE 5 & 6 -->
          <v-row
            v-if="
            $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus1 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null
            "
          >
            <v-col cols="12" md="3">
              <!-- SEM 5 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem5NoteFinale
                "
                :label="$storeUniversite.label.Semestre5"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <!-- NB RATTR S 5 -->
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem5NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages5"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem6NoteFinale
                "
                :label="$storeUniversite.label.Semestre6"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem6NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages6"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus3 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- SEMESTRE 7 & 8  -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus1 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem7NoteFinale
                "
                :label="$storeUniversite.label.Semestre7"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem7NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages7"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem8NoteFinale
                "
                :label="$storeUniversite.label.Semestre8"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem8NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages8"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus4 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Informations MASTER/INGENIEUR -->
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus4 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus1 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null &&
              $storeUniversite.inscription.NiveauDEtude.indexOf(
                $storeCatalogue.DataId.PostBac
              ) < 0
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem9NoteFinale
                "
                :label="$storeUniversite.label.Semestre9"
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                outlined
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem9NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages9"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem10NoteFinale
                "
                :label="$storeUniversite.label.Semestre10"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem10NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages10"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus5 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            v-if="
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus3 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus4 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus1 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus2 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaScientifique &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.PrepaGrandeEcole &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu !=
                $storeCatalogue.DataId.BacPlus5 &&
              $storeUniversite.inscription.InfosMaster
                .VotreDiplomeActuelEnCoursOuObtenu != null &&
              $storeUniversite.inscription.NiveauDEtude.indexOf(
                $storeCatalogue.DataId.PostBac
              ) < 0
            "
          >
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem11NoteFinale
                "
                :label="$storeUniversite.label.Semestre11"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem11NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages11"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem12NoteFinale
                "
                :label="$storeUniversite.label.Semestre12"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [
                        $rules.obligatoire(),
                        $rules.EstNumerique(),
                        $rules.loanMin(ValeurBaremMaster),
                      ]
                    : [$rules.EstNumerique(),
                      $rules.loanMin(ValeurBaremMaster),]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense
                v-model="
                  $storeUniversite.inscription.InfosMaster.Sem12NbDeRattrapage
                "
                :label="$storeUniversite.label.NbrRattrapages12"
                outlined
                :rules="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? [$rules.obligatoireWithZero(), $rules.entier()]
                    : [$rules.entier()]
                "
                :disabled="$storeUniversite.inscription.ReadOnly"
                :class="
                  $storeUniversite.inscription.InfosMaster
                    .VotreDiplomeActuelEnCoursOuObtenu !=
                    $storeCatalogue.DataId.BacPlus6 ||
                  $storeUniversite.inscription.InfosMaster
                    .AvezVousObtenuVotreDiplome === $storeCatalogue.DataId.Oui
                    ? 'asterisk'
                    : ''
                "
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <br/>
    <v-row>
      <span class="required">
        <span class="legend"></span>
      </span>
    </v-row>
    <br />
  </v-form>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.17/vue.js"></script>
<script>
export default {
  data() {
    return {
      Panel: {
        EtudesSuperieures: [0, 1, 2],
        Baccalaureat: [0, 1, 2],
      },
      //réafecter l'objet global
      $storeUniversite: this.$storeUniversite,
      $storeCommun: this.$storeCommun,
      // Licence
      dateObtentionLicence: null,
      menu2: null,
      menu3: null,
      menu4: null,
      dialog: {
        informations: {
          model: false,
          texte: null,
        },
      },
    };
  },
  computed: {
    myDateFormated2() {
      return this.formatDate(
        this.$storeUniversite.inscription.InfosMaster.DateDeFinOuEspere
      );
    },
    myDateFormated3() {
      return this.formatDate(
        this.$storeUniversite.inscription.InfosMaster.DateEntree
      );
    },

    columnValue() {
      return this.$storeUniversite.inscription.InfosMaster
        .VotreDiplomeActuelEnCoursOuObtenu ==
        this.$storeCatalogue.DataId.BacPlus1 ||
        this.$storeUniversite.inscription.InfosMaster
        .VotreDiplomeActuelEnCoursOuObtenu ==
        this.$storeCatalogue.DataId.BacPlus2 ||
        this.$storeUniversite.inscription.InfosMaster
          .VotreDiplomeActuelEnCoursOuObtenu ==
          this.$storeCatalogue.DataId.PrepaScientifique ||
        this.$storeUniversite.inscription.InfosMaster
          .VotreDiplomeActuelEnCoursOuObtenu ==
          this.$storeCatalogue.DataId.PrepaGrandeEcole
        ? 6
        : 3;
    },

    ValeurBaremBac() {
        this.$storeUniversite.NoteBacMaxAutorise = this.$storeUniversite.noteBacMaxAutorise(this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac, this.$storeUniversite.inscription.InfosBac.SpecificationDuBaremeDeBac, this.$storeCatalogue);
        return this.$storeUniversite.NoteBacMaxAutorise
    },

    ValeurBaremMaster() {
      if (this.$storeUniversite.inscription.InfosMaster.VotreEchelleDeNotation !=
        this.$storeCatalogue.DataId.BaremBacAutre) 
        {
          let selectedDiplomeId =
          this.$storeUniversite.inscription.InfosMaster.VotreEchelleDeNotation;
          if (selectedDiplomeId !== null) 
          {
            let selectedDiplome = this.$storeCatalogue.BaremBac.find((d) => d.id === selectedDiplomeId);
            if(selectedDiplome){
              this.$storeUniversite.NoteBacMaxAutoriseMaster = selectedDiplome.lang00;
            }
          }
      } 
      else 
      {
        this.$storeUniversite.NoteBacMaxAutoriseMaster = parseFloat(this.$storeUniversite.inscription.InfosMaster.VeuillezPreciserVotreEchelleDeNotation);
      }

      return this.$storeUniversite.NoteBacMaxAutoriseMaster
    },
  },
  mounted() {
    this.$refs.formulaireInfoScolaire.resetValidation();
  },
  methods: {
    ValiderNotes() {
      this.$refs.formulaireInfoScolaire.validate();
      if (this.$refs.formulaireInfoScolaire.validate()) {
        let self = this;
        this.$storeUniversite.Loader = true;
        Promise.all([
          this.$storeUniversite.ValiderNotes().then((reponse) => {
            if (reponse && reponse.data) {
              this.$storeUniversite.MapperInscriptionExistante(
                reponse.data.formulaire
              );
              if (reponse.data.message) {
                if (reponse.data.message == "annexes") {
                  this.dialog.informations.texte =
                    this.$storeUniversite.label.AnnexesManquantes;
                  this.dialog.informations.model = true;
                } else {
                  this.dialog.informations.texte = reponse.data.message;
                  this.dialog.informations.model = true;
                }
              }
            }
          }),
        ])
          .then(function () {
            self.$storeUniversite.Loader = false;
          })
          .catch((error) => {
            console.log(error);
            self.$storeUniversite.Loader = false;
          });
      } else {
        this.dialog.informations.texte =
          this.$storeUniversite.label.AnnexesManquantes;
        this.dialog.informations.model = true;
      }
    },
    Valider() {
      return this.$refs.formulaireInfoScolaire.validate();
    },

    CheckSpecialite1(specialiteId) {
      if (
        this.$storeUniversite.inscription.InfosBac.Specialite2 !=
        this.$storeCatalogue.DataId.SpecialiteAutre
      ) {
        this.$storeCatalogue.Specialite1Bac =
          this.$storeCatalogue.SpecialiteBac.filter(
            (specialite) => specialite.id !== specialiteId
          );
      }
    },

    CheckSpecialite2(specialiteId) {
      if (
        this.$storeUniversite.inscription.InfosBac.Specialite1 !=
        this.$storeCatalogue.DataId.SpecialiteAutre
      ) {
        this.$storeCatalogue.Specialite2Bac =
          this.$storeCatalogue.SpecialiteBac.filter(
            (specialite) => specialite.id !== specialiteId
          );
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    CheckVilleMaroc() {
      this.$storeUniversite.inscription.InfosBac.DomaineDuBaccalaureat = null;
      if (
        this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
        this.$storeCatalogue.DataId.TypeBacMarocain
      ) {
        this.$storeCatalogue.GetVilleMarocFileData();
        this.$storeCatalogue.GetVilleMarocMasterFileData();
        this.$storeCatalogue.DomaineBacFr =
          this.$storeCatalogue.DomaineBac.filter((obj) => obj.code !== "FR");
      } else {
        this.$storeCatalogue.DomaineBacFr =
          this.$storeCatalogue.DomaineBac.filter((obj) => obj.code !== "");
      }

      // mettre le barem à 20 si bac fr ou maroc
      if (
        this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
          this.$storeCatalogue.DataId.TypeBacMarocain ||
        this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
          this.$storeCatalogue.DataId.TypeBacFrancais
      ) {
        this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac =
          this.$storeCatalogue.DataId.BaremBac20;
        this.$storeUniversite.lectureSeuleBarem = true;
      } else {
        this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac = null;
        this.$storeUniversite.lectureSeuleBarem = false;
      }
    },
    CheckEtablissement() {
      if (
        this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
        this.$storeCatalogue.DataId.TypeBacMarocain
      ) {
        this.$storeUniversite.inscription.InfosBac.Lycee = null;
        this.$storeCatalogue.GetEtablissementsMarocFileData(
          this.$storeUniversite.inscription.InfosBac.VilleDuLycee
        );
      }
    },

    CheckVilleMaster() {
      if (
        this.$storeUniversite.inscription.InfosMaster.PaysObtentionDuDiplome ===
        this.$storeCatalogue.DataId.Maroc
      ) {
        this.$storeCatalogue.GetVilleMarocFileData();
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/InscriptionUniversite.css";
</style>
